export default __webpack_public_path__ + "static/media/tab-slider-2.c7b38550.png";